module.exports = __webpack_public_path__ + "img/s2-3-ja.0c40139a.jpg";